import React from "react";
import {Check, Handshake, Info, Mail, Trophy, Users} from "lucide-react";
import {IPoll, IPollResult, IPollResultOptions, IVoters} from "../../types/poll.types";
import EmployeeAvatar from "../../../employee/avatar/employee-avatar";
import PollResultGraph from "../result-graph";
import {Button} from "antd";

interface ITieResultProps {
    result: IPollResult | undefined;
    selectedPoll: IPoll | null;
    handleDeclareResult: (id: string | undefined) => void;
}

const RenderTieResult = (props: ITieResultProps) => {

    if (props.result?.totalVotes === undefined || props.result.totalVotes <= 0) {
        return null;
    }

    const hadVotePercentage = props.result?.options.every(option => option.votePercentage !== undefined);

    const hadVoterList = props.result?.options?.some(
        (options: IPollResultOptions) => (
            options.voters
        )
    );

    return (
        <div className={'tie-result-container'}>
            <div className={'total-vote-count'}>
                <Users
                    className={'poll-user-icon'}/> {props.selectedPoll?.totalVotes ?? props.selectedPoll?.totalVotes} total
                votes
            </div>
            <div className={'tie-result-heading'}>
                <div className={'tie-icon'}>
                    <Handshake/>
                </div>
                <div>
                    <div className={'tie-text'}>
                        <h5>It's a tie!</h5>
                    </div>
                    <div className={'tie-subText'}>
                        <h6>No single winner could be determined</h6>
                    </div>
                </div>
            </div>

            <div className={'tie-result-grid'}>
                {props.result?.options.map((item: IPollResultOptions) => (
                    item.isWinner && <div className={'vote-details'}>
                        <div className={'trophy-icon'}>
                            <Trophy/>
                        </div>
                        <div className={'option'}>
                            <h5> {item.option}</h5>
                        </div>
                        <div className={'percentage'}>
                            {item.votePercentage && `${item.votePercentage}%`}
                        </div>
                    </div>
                ))}
            </div>

            {
                hadVotePercentage && <PollResultGraph result={props.result}/>
            }

            {
                !props.selectedPoll?.active && props.selectedPoll?.anonymous && !props.selectedPoll?.resultDeclared &&
                <Button type={"primary"} className={'declare-result-btn'}
                        onClick={() => props.handleDeclareResult(props.selectedPoll?.id)}>
                    <Check className={'poll-action-icon'}/> Declare Result
                </Button>
            }

            {
                hadVoterList && <div className={'voter-list-heading'}>
                    <h5> Voters List</h5>
                </div>
            }

            {hadVoterList && <div className={'voter-list-container'}>

                {props.result?.options?.map((item) => (
                    item?.voters?.map((voters: IVoters) => (
                        <div className={'voter-details'}>
                            <div>
                                <EmployeeAvatar
                                    thumbnailId={voters.profilePhotoThumbnailId}
                                    name={{
                                        firstName: voters.name?.firstName,
                                        lastName: voters.name?.lastName
                                    }}
                                />
                            </div>
                            <div className={'voters-name'}>
                                <div>
                                    {voters.name.firstName} {voters.name.middleName} {voters.name.lastName} voted
                                    for <b>{item.option}</b>
                                </div>
                                <div>
                                    <Mail className={'voters-email'}/> {voters.officialEmail}
                                </div>
                            </div>
                        </div>
                    ))
                ))}

            </div>}
            {
                !hadVotePercentage && <div className="result-info">
                    <Info size={18}/>
                    <span>Vote percentages are not included in this result. Only the winner is
            determined from the available data.</span>
                </div>
            }

        </div>
    )
}

export default RenderTieResult;